import { TextFieldProps } from '@material-ui/core/TextField';
import React from 'react';

import { BaseTextField } from './BaseTextField';

export const NumberTextField: React.FC<TextFieldProps> = ({
  onChange,
  ...textFieldProps
}) => {
  const handleChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => {
    if (onChange && event.target.value.match(/^\d*\.?\d*$/)) {
      onChange(event);
    }
  };

  return <BaseTextField onChange={handleChange} {...textFieldProps} />;
};
